import { getArray, get, post, put, removeList } from '../index'

export default {
  list: (params) => getArray('delegations', {
    hasNotifications: true,
    ...params
  }),
  get: (id) => get(`delegations/${id}/notifications`),
  create: (id, data) => post(`delegations/${id}/notifications`, data),
  update: (id, data) => put(`delegations/${id}/notifications`, data),
  remove: (array) => removeList(`delegations/{id}/notifications`, array),
  delegations: () => getArray('delegations', {
    hasNotifications: false
  })
}
